import React from 'react';

/**
 * Large touch-friendly button for the technician mobile app.
 * Minimum 48px height for glove-compatible tapping.
 */

const VARIANTS = {
  primary: { bg: '#6c5ce7', color: '#fff' },
  success: { bg: '#00b894', color: '#fff' },
  danger: { bg: '#d63031', color: '#fff' },
  warning: { bg: '#fdcb6e', color: '#1a1a2e' },
  secondary: { bg: '#30363d', color: '#e6edf3' },
  ghost: { bg: 'transparent', color: '#8b949e' },
};

export default function TechButton({
  children,
  onClick,
  variant = 'primary',
  disabled = false,
  loading = false,
  fullWidth = false,
  icon,
  style: customStyle,
}) {
  const v = VARIANTS[variant] || VARIANTS.primary;

  return (
    <button
      onClick={onClick}
      disabled={disabled || loading}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        minHeight: 48,
        padding: '12px 24px',
        fontSize: 16,
        fontWeight: 600,
        border: 'none',
        borderRadius: 12,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        background: v.bg,
        color: v.color,
        width: fullWidth ? '100%' : 'auto',
        fontFamily: 'inherit',
        transition: 'opacity 0.15s',
        ...customStyle,
      }}
    >
      {loading ? (
        <span style={{ fontSize: 18 }}>...</span>
      ) : (
        <>
          {icon && <span style={{ fontSize: 20 }}>{icon}</span>}
          {children}
        </>
      )}
    </button>
  );
}
